module.exports = __webpack_public_path__ + "img/ranking-bg.83172fb1.png";